import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';

const LokaceList = lazy(() =>
  import('@/modules/uskladneni/LokaceList').then((m) => ({ default: m.LokaceList })),
);

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/servis/lokace',
  component: () => (
    <Suspense fallback={null}>
      <LokaceList />
    </Suspense>
  ),
});
